module.exports = __webpack_public_path__ + "img/testimonial_1.30b82089.png";